const dateFormat = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
const timeFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });

const noteDate = (iso: string) => {
  const date = new Date(iso);

  return { date: dateFormat.format(date), time: timeFormat.format(date) };
};

export default noteDate;
